import { useQuery } from "@tanstack/react-query";
import { TermsDocumentType } from "@/typedefs/termsDocument";
import queryClient from "@/utils/queryClient";
import { termsDocumentsKeys } from "@/utils/queryKeyFactories";
import request from "@/utils/request";
export const getActiveTermsDocument = async (type) => {
    const response = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/terms-documents/active`, {
        method: "GET",
        params: { type },
    });
    if ("error" in response) {
        throw new Error(response?.error);
    }
    return response?.data;
};
export const removeTermsDocumentsQueries = () => {
    queryClient.removeQueries({ queryKey: termsDocumentsKeys.all() });
};
export const useActiveTermsDocument = (type = TermsDocumentType.TermsAndConditions) => useQuery({
    queryKey: termsDocumentsKeys.active(type),
    queryFn: () => getActiveTermsDocument(type),
    staleTime: Infinity,
    cacheTime: Infinity,
});
